import request from '~/utils/http';
// 我的产品
export function getOrderStockMessage(data) {
  return request({
    url: 'api/HKOrderStore/GetList',
    method: "post",
    data: data
  })
}
// 报关商品查询
export function getProductStockMessage(data) {
  return request({
    url: 'api/HKProductStore/GetList',
    method: "post",
    data: data
  })
}
